import { createAction, props } from '@ngrx/store';

export const loadShipperCostAnalysisLogs = createAction(
    '[Logs] Load Shipper Cost Analysis Logs',
    props<{ shipperIds: string }>()
);

export const loadShipperCostAnalysisLogsSuccess = createAction(
    '[Logs] Load Shipper Cost Analysis Logs Success',
    props<{ shipperCostAnalysisLogs: any[] }>()
);

export const loadShipperCostAnalysisLogsFailure = createAction(
    '[Logs] Load Shipper Cost Analysis Logs Failure',
    props<{ error: string }>()
);

export const loadIncompleteRfqs = createAction(
    '[Logs] Load Incomplete RFQs',
    props<{ shipper: string }>()
);

export const loadIncompleteRfqsSuccess = createAction(
    '[Logs] Load Incomplete RFQs Success',
    props<{ incompleteRfqs: any[] }>()
);

export const loadIncompleteRfqsFailure = createAction(
    '[Logs] Load Incomplete RFQs Failure',
    props<{ error: string }>()
);

export const loadCargyChatLogs = createAction(
    '[Logs] Load Cargy Chat Logs',
    props<{ shipper: string }>()
);

export const loadCargyChatLogsSuccess = createAction(
    '[Logs] Load Cargy Chat Logs Success',
    props<{ cargyChatLogs: any[] }>()
);

export const loadCargyChatLogsFailure = createAction(
    '[Logs] Load Cargy Chat Logs Failure',
    props<{ error: string }>()
);